import { useEffect, useRef, useState } from "react";
import { FaFacebookF, FaInstagram, FaWhatsapp } from "react-icons/fa";
import { Link, NavLink, useLocation } from "react-router-dom";

const serviceGroups = [
  {
    title: "Anti-Aging",
    links: [
      ["Mezoterapi", "/mezoterapi"],
      ["Gıdı Lipoliz", "/gidi-lipoliz"],
      ["PRP", "/prp"],
      ["Gençlik Aşısı", "/genclik-asisi"],
      ["Boyun-Dekolte-El Gençleştirme Tedavileri", "/boyun-dekolte-el-genclestirme-tedavileri"],
      ["Göz Altı Mezoterapisi", "/goz-alti-mezoterapisi"],
    ],
  },
  {
    title: "YÜZ MİMARİSİ",
    links: [
      ["İp Askı Estetiği", "/ip-aski-estetigi"],
      ["Altın İğne Tedavisi", "/altin-igne-tedavisi"],
      ["Dolgu Uygulamaları", "/dolgu-uygulamalari"],
      ["Botox Uygulaması", "/botox-uygulamasi"],
      ["Aşırı Terleme Tedavisi", "/asiri-terleme-tedavisi"],
      ["Masseter Botox", "/masseter-botox"],
      ["Migren Botox", "/migren-botox"],
    ],
  },
  {
    title: "VÜCUT TEDAVİLERİ",
    links: [
      ["Ozon Terapi", "/ozon-terapi"],
      ["Glutatyon C Tedavisi", "/glutatyon-c-tedavisi"],
    ],
  },
  {
    title: "CİLT PROBLEMLERİ",
    links: [
      ["Leke Tedavileri ve Cilt Problemleri Tedavileri", "/leke-tedavileri-ve-cilt-problemleri-tedavileri"],
    ],
  },
  {
    title: "CİLT BAKIM YÖNTEMLERİ",
    links: [
      ["Kimyasal Peeling", "/kimyasal-peeling"],
      ["Enzim Peeling", "/enzim-peeling"],
      ["Hydrafacial", "/hydrafacial"],
    ],
  },
  {
    title: "SAÇ TEDAVİLERİ",
    links: [
      ["Saç PRP", "/sac-prp"],
      ["Saç Mezoterpaisi", "/sac-mezoterapisi"],
    ],
  },
  {
    title: "Lazer Epilasyon",
    links: [["Lazer Epilasyon", "/lazer-epilasyon"]],
  },
  {
    title: "Brands",
    links: [["Brands", "/brands"]],
  },
];

const Brand = () => (
  <span className="brand" aria-label="Dr. Tülay Yıldırım Estetik ve Güzellik">
    <span className="brand-mark" aria-hidden="true">
      <span>TY</span>
    </span>
    <span className="brand-copy">
      <span className="brand-name">DR. TÜLAY YILDIRIM</span>
      <span className="brand-tagline">ESTETİK &amp; GÜZELLİK</span>
    </span>
  </span>
);

const SocialLinks = ({ mobile = false }) => (
  <div className={mobile ? "nav-socials nav-socials-mobile" : "nav-socials"}>
    <a
      href="https://www.facebook.com/profile.php?id=100076111957553"
      target="_blank"
      rel="noreferrer"
      aria-label="Facebook"
    >
      <FaFacebookF />
    </a>
    <a
      href="https://www.instagram.com/drtulayyildirim"
      target="_blank"
      rel="noreferrer"
      aria-label="Instagram"
    >
      <FaInstagram />
    </a>
    <a
      href="https://wa.me/905304292306"
      target="_blank"
      rel="noreferrer"
      aria-label="WhatsApp"
    >
      <FaWhatsapp />
    </a>
  </div>
);

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);
  const location = useLocation();
  const navRef = useRef(null);

  useEffect(() => {
    setMenuOpen(false);
    setServicesOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    const closeOnEscape = (event) => {
      if (event.key === "Escape") {
        setMenuOpen(false);
        setServicesOpen(false);
      }
    };
    document.addEventListener("keydown", closeOnEscape);
    return () => document.removeEventListener("keydown", closeOnEscape);
  }, []);

  useEffect(() => {
    document.body.classList.toggle("menu-locked", menuOpen);
    return () => document.body.classList.remove("menu-locked");
  }, [menuOpen]);

  return (
    <header className="site-header" ref={navRef}>
      <nav className="nav-shell" aria-label="Ana navigasyon">
        <Link className="brand-link" to="/" onClick={() => setMenuOpen(false)}>
          <Brand />
        </Link>

        <div className="desktop-nav">
          <NavLink to="/" end>Ana Sayfa</NavLink>
          <NavLink to="/hakkimizda">Hakkımızda</NavLink>
          <button
            className={`services-trigger ${servicesOpen ? "is-open" : ""}`}
            type="button"
            aria-expanded={servicesOpen}
            aria-controls="services-menu"
            onClick={() => setServicesOpen((current) => !current)}
          >
            Hizmetlerimiz
            <span className="chevron" aria-hidden="true" />
          </button>
          <NavLink to="/iletisim">İletişim</NavLink>
        </div>

        <SocialLinks />

        <button
          className={`menu-toggle ${menuOpen ? "is-open" : ""}`}
          type="button"
          aria-label={menuOpen ? "Menüyü kapat" : "Menüyü aç"}
          aria-expanded={menuOpen}
          aria-controls="mobile-menu"
          onClick={() => setMenuOpen((current) => !current)}
        >
          <span />
          <span />
        </button>
      </nav>

      <div
        id="services-menu"
        className={`mega-menu ${servicesOpen ? "is-open" : ""}`}
        aria-hidden={!servicesOpen}
      >
        <div className="mega-menu-inner">
          {serviceGroups.map((group) => (
            <div className="service-group" key={group.title}>
              <p>{group.title}</p>
              <div>
                {group.links.map(([label, path]) => (
                  <Link to={path} key={path}>{label}</Link>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>

      <div id="mobile-menu" className={`mobile-menu ${menuOpen ? "is-open" : ""}`}>
        <div className="mobile-menu-scroll">
          <NavLink to="/" end>Ana Sayfa</NavLink>
          <NavLink to="/hakkimizda">Hakkımızda</NavLink>
          <button
            className="mobile-services-trigger"
            type="button"
            onClick={() => setServicesOpen((current) => !current)}
            aria-expanded={servicesOpen}
          >
            Hizmetlerimiz
            <span className="menu-index">03</span>
          </button>
          <div className={`mobile-services ${servicesOpen ? "is-open" : ""}`}>
            {serviceGroups.map((group) => (
              <div className="mobile-service-group" key={group.title}>
                <p>{group.title}</p>
                {group.links.map(([label, path]) => (
                  <Link to={path} key={path}>{label}</Link>
                ))}
              </div>
            ))}
          </div>
          <NavLink to="/iletisim">İletişim</NavLink>
          <SocialLinks mobile />
        </div>
      </div>
      <button
        className={`nav-backdrop ${servicesOpen ? "is-open" : ""}`}
        onClick={() => setServicesOpen(false)}
        aria-label="Hizmetler menüsünü kapat"
        tabIndex={servicesOpen ? 0 : -1}
      />
    </header>
  );
}
